import { Command } from 'commander';
import { login } from './login';
export function LoginCommand(): Command {
  const cmd = new Command('login')
    .alias('l')
    .description('Login to HexaSync')
    .argument('host', 'The HexaSync Cluster, e.g: hexasync.com')
    .action(login);
  return cmd;
}
